import { render } from "./CardOfficePage.vue?vue&type=template&id=af68bc52"
import script from "./CardOfficePage.vue?vue&type=script&lang=js"
export * from "./CardOfficePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__